export interface IDemographics {
    DAUID: number;
    PopulationSize: number;
    MedianAge: number;
    MedianAgeStr: string;
    AvgHouseholdSize: number;
    AvgHouseholdSizeStr: string;
    AvgHouseholdIncome: number;
    AvgHouseholdIncomeStr: string;
    NumHouseholds: number;
    Pop0to4: number;
    Pop5to9: number;
    Pop10to14: number;
    Pop15to19: number;
    Pop20to24: number;
    Pop25to29: number;
    Pop30to34: number;
    Pop35to39: number;
    Pop40to44: number;
    Pop45to49: number;
    Pop50to54: number;
    Pop55to59: number;
    Pop60to64: number;
    Pop65to69: number;
    Pop70to74: number;
    Pop75to79: number;
    Pop80to84: number;
    Pop85Plus: number;
    Pop2016: number;
    Pop2021: number;
    Pop2024: number;
    Pop2026: number;
    Pop2031: number;
    EdNoCertDipDeg: number;
    EdHighSch: number;
    EdAppTradeDip: number;
    EdCollege: number;
    EdUniBelowBach: number;
    EdUniDeg: number;
    EdUniBach: number;
    EdUniBachPlus: number;
    StatMarried: number;
    StatCommon: number;
    StatSeparated: number;
    StatSingle: number;
    StatDivorce: number;
    StatWidow: number;
    HouseInc0to20: number;
    HouseInc20to40: number;
    HouseInc40to60: number;
    HouseInc60to80: number;
    HouseInc80to100: number;
    HouseInc100to150: number;
    HouseInc150to200: number;
    HouseInc200Plus: number;
    ChildHome0to4: number;
    ChildHome5to9: number;
    ChildHome10to14: number;
    ChildHome15to19: number;
    ChildHome20to24: number;
    ChildHome25Plus: number;
    OwnershipRent: number;
    OwnershipOwn: number;
    ContructDatePre1960: number;
    ContructDatePre1961to1980: number;
    ContructDatePre1981to1990: number;
    ContructDatePre1991to2000: number;
    ContructDatePre2001to2005: number;
    ContructDatePre2006to2011: number;
    ContructDatePre2011to2016: number;
    ContructDatePre2016Plus: number;
    OccupNA: number;
    OccupMangement: number;
    OccupBusFinAdmin: number;
    OccupNatAppSci: number;
    OccupHealth: number;
    OccupEdLawGov: number;
    OccupArtCultRec: number;
    OccupSaleService: number;
    OccupTradeTrans: number;
    OccupMan: number;
    OccupNatResAgri: number;
}

export class Demographics implements IDemographics {
    public DAUID = -1;
    public PopulationSize = -1;
    public MedianAge = -1;
    public MedianAgeStr = '';
    public AvgHouseholdSize = -1;
    public AvgHouseholdSizeStr = '';
    public AvgHouseholdIncome = -1;
    public AvgHouseholdIncomeStr = '';
    public NumHouseholds = -1;
    public Pop0to4 = -1;
    public Pop5to9 = -1;
    public Pop10to14 = -1;
    public Pop15to19 = -1;
    public Pop20to24 = -1;
    public Pop25to29 = -1;
    public Pop30to34 = -1;
    public Pop35to39 = -1;
    public Pop40to44 = -1;
    public Pop45to49 = -1;
    public Pop50to54 = -1;
    public Pop55to59 = -1;
    public Pop60to64 = -1;
    public Pop65to69 = -1;
    public Pop70to74 = -1;
    public Pop75to79 = -1;
    public Pop80to84 = -1;
    public Pop85Plus = -1;
    public Pop2016 = -1;
    public Pop2021 = -1;
    public Pop2024 = -1;
    public Pop2026 = -1;
    public Pop2031 = -1;
    public EdNoCertDipDeg = -1;
    public EdHighSch = -1;
    public EdAppTradeDip = -1;
    public EdCollege = -1;
    public EdUniBelowBach = -1;
    public EdUniDeg = -1;
    public EdUniBach = -1;
    public EdUniBachPlus = -1;
    public StatMarried = -1;
    public StatCommon = -1;
    public StatSeparated = -1;
    public StatSingle = -1;
    public StatDivorce = -1;
    public StatWidow = -1;
    public HouseInc0to20 = -1;
    public HouseInc20to40 = -1;
    public HouseInc40to60 = -1;
    public HouseInc60to80 = -1;
    public HouseInc80to100 = -1;
    public HouseInc100to150 = -1;
    public HouseInc150to200 = -1;
    public HouseInc200Plus = -1;
    public ChildHome0to4 = -1;
    public ChildHome5to9 = -1;
    public ChildHome10to14 = -1;
    public ChildHome15to19 = -1;
    public ChildHome20to24 = -1;
    public ChildHome25Plus = -1;
    public OwnershipRent = -1;
    public OwnershipOwn = -1;
    public ContructDatePre1960 = -1;
    public ContructDatePre1961to1980 = -1;
    public ContructDatePre1981to1990 = -1;
    public ContructDatePre1991to2000 = -1;
    public ContructDatePre2001to2005 = -1;
    public ContructDatePre2006to2011 = -1;
    public ContructDatePre2011to2016 = -1;
    public ContructDatePre2016Plus = -1;
    public OccupNA = -1;
    public OccupMangement = -1;
    public OccupBusFinAdmin = -1;
    public OccupNatAppSci = -1;
    public OccupHealth = -1;
    public OccupEdLawGov = -1;
    public OccupArtCultRec = -1;
    public OccupSaleService = -1;
    public OccupTradeTrans = -1;
    public OccupMan = -1;
    public OccupNatResAgri = -1;

    constructor(
        demoObject: any,
    ) {
        this.DAUID = demoObject.dauid;
        this.PopulationSize = demoObject.populationSize;
        this.MedianAge = demoObject.medianAge;
        this.MedianAgeStr = demoObject.medianAgeStr;
        this.AvgHouseholdSize = demoObject.avgHouseholdSize;
        this.AvgHouseholdSizeStr = demoObject.avgHouseholdSizeStr;
        this.AvgHouseholdIncome = demoObject.avgHouseholdIncome;
        this.AvgHouseholdIncomeStr = demoObject.avgHouseholdIncomeStr;
        this.NumHouseholds = demoObject.numHouseholds;
        this.Pop0to4 = demoObject.pop0to4;
        this.Pop5to9 = demoObject.pop5to9;
        this.Pop10to14 = demoObject.pop10to14;
        this.Pop15to19 = demoObject.pop15to19;
        this.Pop20to24 = demoObject.pop20to24;
        this.Pop25to29 = demoObject.pop25to29;
        this.Pop30to34 = demoObject.pop30to34;
        this.Pop35to39 = demoObject.pop35to39;
        this.Pop40to44 = demoObject.pop40to44;
        this.Pop45to49 = demoObject.pop45to49;
        this.Pop50to54 = demoObject.pop50to54;
        this.Pop55to59 = demoObject.pop55to59;
        this.Pop60to64 = demoObject.pop60to64;
        this.Pop65to69 = demoObject.pop65to69;
        this.Pop70to74 = demoObject.pop70to74;
        this.Pop75to79 = demoObject.pop75to79;
        this.Pop80to84 = demoObject.pop80to84;
        this.Pop85Plus = demoObject.pop85Plus;
        this.Pop2016 = demoObject.pop2016;
        this.Pop2021 = demoObject.pop2021;
        this.Pop2024 = demoObject.pop2024;
        this.Pop2026 = demoObject.pop2026;
        this.Pop2031 = demoObject.pop2031;
        this.EdNoCertDipDeg = demoObject.edNoCertDipDeg;
        this.EdHighSch = demoObject.edHighSch;
        this.EdAppTradeDip = demoObject.edAppTradeDip;
        this.EdCollege = demoObject.edCollege;
        this.EdUniBelowBach = demoObject.edUniBelowBach;
        this.EdUniDeg = demoObject.edUniDeg;
        this.EdUniBach = demoObject.edUniBach;
        this.EdUniBachPlus = demoObject.edUniBachPlus;
        this.StatMarried = demoObject.statMarried;
        this.StatCommon = demoObject.statCommon;
        this.StatSeparated = demoObject.statSeparated;
        this.StatSingle = demoObject.statSingle;
        this.StatDivorce = demoObject.statDivorce;
        this.StatWidow = demoObject.statWidow;
        this.HouseInc0to20 = demoObject.houseInc0to20;
        this.HouseInc20to40 = demoObject.houseInc20to40;
        this.HouseInc40to60 = demoObject.houseInc40to60;
        this.HouseInc60to80 = demoObject.houseInc60to80;
        this.HouseInc80to100 = demoObject.houseInc80to100;
        this.HouseInc100to150 = demoObject.houseInc100to150;
        this.HouseInc150to200 = demoObject.houseInc150to200;
        this.HouseInc200Plus = demoObject.houseInc200Plus;
        this.ChildHome0to4 = demoObject.childHome0to4;
        this.ChildHome5to9 = demoObject.childHome5to9;
        this.ChildHome10to14 = demoObject.childHome10to14;
        this.ChildHome15to19 = demoObject.childHome15to19;
        this.ChildHome20to24 = demoObject.childHome20to24;
        this.ChildHome25Plus = demoObject.childHome25Plus;
        this.OwnershipRent = demoObject.ownershipRent;
        this.OwnershipOwn = demoObject.ownershipOwn;
        this.ContructDatePre1960 = demoObject.contructDatePre1960;
        this.ContructDatePre1961to1980 = demoObject.contructDatePre1961to1980;
        this.ContructDatePre1981to1990 = demoObject.contructDatePre1981to1990;
        this.ContructDatePre1991to2000 = demoObject.contructDatePre1991to2000;
        this.ContructDatePre2001to2005 = demoObject.contructDatePre2001to2005;
        this.ContructDatePre2006to2011 = demoObject.contructDatePre2006to2011;
        this.ContructDatePre2011to2016 = demoObject.contructDatePre2011to2016;
        this.ContructDatePre2016Plus = demoObject.contructDatePre2016Plus;
        this.OccupNA = demoObject.occupNA;
        this.OccupMangement = demoObject.occupMangement;
        this.OccupBusFinAdmin = demoObject.occupBusFinAdmin;
        this.OccupNatAppSci = demoObject.occupNatAppSci;
        this.OccupHealth = demoObject.occupHealth;
        this.OccupEdLawGov = demoObject.occupEdLawGov;
        this.OccupArtCultRec = demoObject.occupArtCultRec;
        this.OccupSaleService = demoObject.occupSaleService;
        this.OccupTradeTrans = demoObject.occupTradeTrans;
        this.OccupMan = demoObject.occupMan;
        this.OccupNatResAgri = demoObject.occupNatResAgri;
    }
}

